import React from 'react'
import './Home.css'

const NotFound = () => {
    return (
        <div id="main">
    	<div class="fof">
        		<h1>Error 404</h1>
    	</div>
        </div>
    )
}

export default NotFound
